import { NOT_REQUIRED, OPTIONAL, REQUIRED, ACCEPTED, REJECTED, AMENDED } from './constants';

export const checkForVersionDifferences = (previousVersion, quantity, price, city, country, deliveryDate) => {
  const differences = {};

  if (Number(quantity) !== Number(previousVersion.quantity)) {
    differences.quantity = true;
  } else {
    differences.quantity = false;
  }

  if (Number(price) !== Number(previousVersion.price)) {
    differences.price = true;
  } else {
    differences.price = false;
  }

  if (city !== previousVersion.city) {
    differences.city = true;
  } else {
    differences.city = false;
  }

  if (country !== previousVersion.country) {
    differences.country = true;
  } else {
    differences.country = false;
  }

  if (deliveryDate?.getTime() !== new Date(previousVersion.deliveryDate).getTime()) {
    differences.deliveryDate = true;
  } else {
    differences.deliveryDate = false;
  }

  return differences;
};

export const checkForUserDifferences = (currentVersion, quantity, price, city, country, deliveryDate, folders) => {
  if (Number(quantity) !== Number(currentVersion.quantity)) {
    return true;
  }

  if (Number(price) !== Number(currentVersion.price)) {
    return true;
  }

  if (city && city !== currentVersion.city) {
    return true;
  }

  if (country && country !== currentVersion.country) {
    return true;
  }

  if (deliveryDate && new Date(deliveryDate).getTime() !== new Date(currentVersion.deliveryDate).getTime()) {
    return true;
  }

  let numberOfDocuments = 0;
  for (const folder of folders) {
    const { categories } = folder;

    for (const category of categories) {
      const { documents } = category;
      numberOfDocuments += documents.length;
    }
  }

  if (currentVersion?.documents?.length !== numberOfDocuments) {
    return true;
  }

  for (const document of currentVersion.documents) {
    const [folderName, categoryName] = document.subject.split('_$');
    const folder = folders.find((folder) => folder.name === folderName);
    const category = folder.categories.find((category) => category.name === categoryName);
    const documentInFolder = category.documents.find((doc) => doc.externalReference === document.externalReference);

    if (
      !documentInFolder ||
      documentInFolder.buyerStatus !== document.buyerStatus ||
      documentInFolder.atpStatus !== document.atpStatus
    ) {
      return true;
    }
  }

  return false;
};

export const documentCategoryStatusList = [
  { label: NOT_REQUIRED, value: NOT_REQUIRED },
  { label: OPTIONAL, value: OPTIONAL },
  { label: REQUIRED, value: REQUIRED },
];

export const documentStatusList = [
  { label: ACCEPTED, value: ACCEPTED },
  { label: AMENDED, value: AMENDED },
  { label: REJECTED, value: REJECTED },
];

export const documentFolders = [
  {
    name: 'Legal Agreements',
    categories: [
      {
        name: 'Sales & Purchase Agreement',
        status: REQUIRED,
        documents: [],
      },
      {
        name: 'Term Sheets',
        status: REQUIRED,
        documents: [],
      },
      {
        name: 'Insurance Cover',
        status: REQUIRED,
        documents: [],
      },
      {
        name: 'Notes',
        status: OPTIONAL,
        documents: [],
      },
    ],
  },
  {
    name: 'Product',
    categories: [
      {
        name: 'Photos',
        status: REQUIRED,
        documents: [],
      },
      {
        name: 'Specifications',
        status: REQUIRED,
        documents: [],
      },
      {
        name: 'Laboratory Reports',
        status: REQUIRED,
        documents: [],
      },
      {
        name: 'Certificate of Origin',
        status: REQUIRED,
        documents: [],
      },
      {
        name: 'Notes',
        status: OPTIONAL,
        documents: [],
      },
    ],
  },
  {
    name: 'Logistics',
    categories: [
      {
        name: 'Export Documents',
        status: REQUIRED,
        documents: [],
      },
      {
        name: 'Quotes',
        status: REQUIRED,
        documents: [],
      },
      {
        name: 'Invoices',
        status: REQUIRED,
        documents: [],
      },
      {
        name: 'Insurance Quotes',
        status: REQUIRED,
        documents: [],
      },
      {
        name: 'Delivery Notes',
        status: REQUIRED,
        documents: [],
      },
      {
        name: 'Release Notes',
        status: REQUIRED,
        documents: [],
      },
      {
        name: 'Notes',
        status: OPTIONAL,
        documents: [],
      },
    ],
  },
  {
    name: 'Finance',
    categories: [
      {
        name: 'Invoices',
        status: REQUIRED,
        documents: [],
      },
      {
        name: 'Proofs of Payment',
        status: REQUIRED,
        documents: [],
      },
      {
        name: 'Pro-Forma Invoices',
        status: REQUIRED,
        documents: [],
      },
      {
        name: 'Notes',
        status: OPTIONAL,
        documents: [],
      },
    ],
  },
  {
    name: 'Compliance, Customs & Regulations',
    categories: [
      {
        name: 'Customs Regulations',
        status: REQUIRED,
        documents: [],
      },
      {
        name: 'Export Regulations',
        status: REQUIRED,
        documents: [],
      },
      {
        name: 'VAT Duties / Tariffs',
        status: REQUIRED,
        documents: [],
      },
      {
        name: 'Import Duties',
        status: REQUIRED,
        documents: [],
      },
      {
        name: 'Notes',
        status: OPTIONAL,
        documents: [],
      },
    ],
  },
  {
    name: 'Incidents',
    categories: [
      {
        name: 'Pictures',
        status: OPTIONAL,
        documents: [],
      },
      {
        name: 'Damages / Product Issues',
        status: OPTIONAL,
        documents: [],
      },
      {
        name: 'Rejections',
        status: OPTIONAL,
        documents: [],
      },
      {
        name: 'Payments Not Reflecting',
        status: OPTIONAL,
        documents: [],
      },
      {
        name: 'Lost Cargo',
        status: OPTIONAL,
        documents: [],
      },
      {
        name: 'Notes',
        status: OPTIONAL,
        documents: [],
      },
    ],
  },
  {
    name: 'Miscellaneous',
    categories: [
      {
        name: 'Notes',
        status: OPTIONAL,
        documents: [],
      },
    ],
  },
];
